import { useState} from "react";
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

import useStyles from './styles';

function Search() {
    return (
        <></>
    )
}

export default Search;